import React, { useEffect } from 'react'
import useVH from 'react-vh'

import { isNull } from 'lodash'

import { apiFetch } from 'plugin-attributes-manager/shared/utils/index'
import { useRouteContext } from 'plugin-attributes-manager/shared/hooks/RouteContext'

import TemplateContainer from 'plugin-attributes-manager/shared/components/TemplateContainer/TemplateContainer'
import Attributes from './pages/Attributes'
import AttributesProvider, { AttributesContext } from './Context/AttributesProvider'

const App: React.FC = () => {
    const { tab, id, selectTab } = useRouteContext()
    const { loading, setLoading } = React.useContext(AttributesContext)
    useVH()

    return (
        <TemplateContainer>
            <Attributes />
        </TemplateContainer>
    )
}

export default () => (
    <AttributesProvider>
        <App />
    </AttributesProvider>
)
